module.exports = __webpack_public_path__ + "static/media/play_icon.14564b0a.svg";